var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    fillOpacity: 0.54,
    d: "M9.924 4.393c.385-.667 1.348-.667 1.732 0l8.059 13.957c.385.667-.096 1.5-.866 1.5H2.732c-.77 0-1.25-.833-.866-1.5L9.924 4.393z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#451E14",
    fillRule: "evenodd",
    d: "M9.79 16.076V9.192h2v6.884h-2zM9.79 17.65v-1.048h2v1.049h-2z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.117,
    x2: 20.444,
    y1: 11.372,
    y2: 11.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertRed);
export default __webpack_public_path__ + "static/media/icon-alert-red.6b644b76.svg";
export { ForwardRef as ReactComponent };